/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconButton } from '@fluentui/react';

import { withAdsStudioStyles } from '../../../theme/with-ads-studio-styles';
import { getCellDeletionButtonDecoratorStyle } from '../styles/tiles-grid-cell-deletion-button-decorator-style';

const iconProps = { iconName: 'Clear' };

const CellDeletionButtonDecorator = ({
  item, onDelete, children, classes,
}) => {
  const onClick = (event) => {
    if (onDelete) {
      onDelete(item);
    }
    if (event.stopPropagation) { event.stopPropagation(); }
    if (event.preventDefault) { event.preventDefault(); }
  };

  return (
    <>
      {children}
      <div className={classnames('grid-cell-deletion-button-decorator', classes.cellDeletionButtonDecorator)}>
        <IconButton
          iconProps={iconProps}
          onClick={onClick}
          ariaLabel="Delete image"
          disabled={false}
          className={classnames('delete-button', classes.deleteButton)}
        />
      </div>
    </>
  );
};

CellDeletionButtonDecorator.propTypes = {
  item: PropTypes.shape({}).isRequired,
  onDelete: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    cellDeletionButtonDecorator: PropTypes.string,
    deleteButton: PropTypes.string,
  }).isRequired,
};

CellDeletionButtonDecorator.defaultProps = {
  onDelete: undefined,
};

export const TilesGridCellDeletionButtonDecorator = withAdsStudioStyles(
  CellDeletionButtonDecorator,
  getCellDeletionButtonDecoratorStyle
);
